import {useState} from "react";
import {Box, Typography, useMediaQuery, Link} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import tempTermsData from '../../../../assets/data/onboardData.json'
import footerLogo from '../../../../assets/images/onboardPage/astellas_white_logo.png'
import {footerStyles, MAT_DATE, MAT_NUMBER} from "./footer-helpers"
import {TermsDialog} from "./TermsDialog";
import {PrivacyPolicyDialog} from "./PrivacyPolicyDialog";
import TransMsg from "./../../transMessage";
import {theme} from "../../../../utils";

export const Footer = () => {
    const {t} = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down(950))
    const navigate = useNavigate();

    const [openTermsDialog, setOpenTermsDialog] = useState<boolean>(false)
    const [openPrivacyDialog, setOpenPrivacyDialog] = useState<boolean>(false)

    const handleContactUsNavigation = () => {
        navigate('/contact-us');
        window.scrollTo(0, 0); // Force scroll to top after navigation
    };

    const privacyAndTermsData = [
        {
            title: t(TransMsg.TERMS_TITLE),
            updatedDate: "June 2026",
            data: tempTermsData?.data
        },
        {
            title: t(TransMsg.PRIVACY_TITLE),
            updatedDate: "February 2023",
            data: tempTermsData?.data
        }
    ]

    return (
        <>
            <footer>
                <Box sx={footerStyles.footerWrapper}>
                    <Box sx={{maxWidth:'1340px'}}>
                        <Box sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mt: '49px',
                        }}>
                            <img src={footerLogo} style={{height: "*", width: "177px"}} alt='footer-logo'/>

                            <Box sx={{display: "flex", flexDirection: "row", pt: '25px'}}>
                                <Box sx={{cursor: "pointer"}} onClick={handleContactUsNavigation}>
                                    <Typography sx={{...footerStyles.footerLabel, fontWeight: 500, fontSize: '18px'}}>
                                        Contact Us
                                    </Typography>
                                </Box>
                                <Typography sx={[footerStyles.footerLabel, {
                                    mx: "1rem",
                                    fontWeight: 500,
                                    fontSize: '18px'
                                }]}>|</Typography>
                                <Box sx={{cursor: "pointer"}} onClick={() => setOpenTermsDialog(true)}>
                                    <Typography sx={{...footerStyles.footerLabel, fontWeight: 500, fontSize: '18px'}}>Terms
                                        of Use</Typography>
                                </Box>
                                <Typography sx={[footerStyles.footerLabel, {
                                    mx: "1rem",
                                    fontWeight: 500,
                                    fontSize: '18px'
                                }]}>|</Typography>
                                <Box sx={{cursor: "pointer"}} onClick={() => setOpenPrivacyDialog(true)}>
                                    <Typography sx={{...footerStyles.footerLabel, fontWeight: 500, fontSize: '18px'}}>Privacy
                                        Policy</Typography>
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            mt: '56px'
                        }}>
                            <Typography sx={{...footerStyles.footerLabel, mb: '10px', textAlign: 'left', verticalAlign: 'top'}}>
                                This webpage is intended for US audiences only.
                            </Typography>
                            <Box sx={{display: "flex", flexDirection: "row"}}>
                                <Typography sx={{...footerStyles.footerLabel, mb: '10px', color: '#FFFFF', marginRight: '10px', verticalAlign: 'top'}}>
                                    {MAT_NUMBER}
                                </Typography>

                                <Typography sx={{...footerStyles.footerLabel, mb: '10px', color: '#FFFFF', verticalAlign: 'top'}}>
                                    {MAT_DATE}
                                </Typography>
                            </Box>
                        </Box>

                        <Typography sx={{...footerStyles.footerLabel, mt: '15px', mb: '10px', textAlign: 'left', verticalAlign: 'top'}}>
                            © {new Date().getFullYear()} Astellas Pharma Inc. or its affiliates. All trademarks are the property of their respective owners.
                        </Typography>

                        <Box sx={{mt: '15px'}} textAlign={isMobile ? "center" : "left"}>
                            <Typography sx={{...footerStyles.footerLabel, fontWeight: "700"}}>
                                About Astellas
                            </Typography>

                            <Typography sx={{...footerStyles.footerLabel, mb: '25px'}}>

                                Astellas is a global life sciences company committed to turning innovative science into VALUE
                                for patients. We provide transformative therapies in disease areas that include oncology,
                                ophthalmology, urology, immunology and women's health. Through our research and development
                                programs, we are pioneering new healthcare solutions for diseases with high unmet medical need.
                                Learn more at&nbsp;
                                <Link
                                    href="https://www.astellas.com/en"
                                    target='_blank'
                                    rel="noreferrer"
                                    sx={{
                                        ...footerStyles.footerLabel,
                                        fontWeight: 400,
                                        textDecoration: 'underline',
                                        textUnderlineOffset: '0%',
                                        textDecorationThickness: '0%',
                                        color: '#FFFFFF',
                                        '&:visited': {
                                            color: '#FFFFFF',
                                        },
                                    }}>
                                    https://www.astellas.com
                                </Link>.

                            </Typography>

                            <Typography sx={{...footerStyles.footerLabel, mb: '56px'}}>
                                The content or material Astellas provides through this website is provided for informational purposes
                                only and should not be construed as medical or other professional advice or opinion. Astellas does not
                                offer personalized medical advice or patient-specific treatment advice. Use of this site is not a
                                substitute for a call or visit to, or consultation with, your physician or healthcare professional.
                                You should not rely on the site or any other service offered by or through this site for medical
                                diagnosis or treatment. YOU SHOULD NEVER DISREGARD OR DELAY SEEKING MEDICAL ADVICE BECAUSE OF
                                SOMETHING THAT YOU HAVE SEEN ON THIS SITE.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </footer>
            <TermsDialog
                showTermsDialog={openTermsDialog}
                contentData={privacyAndTermsData[0]}
                onCloseTermsDialog={() => setOpenTermsDialog(false)}/>
            <PrivacyPolicyDialog
                showPrivacyPolicyDialog={openPrivacyDialog}
                contentData={privacyAndTermsData[1]}
                onClosePrivacyPolicyDialog={() => setOpenPrivacyDialog(false)}/>
        </>
    );
};

